/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '~/lib/api/axiosClient';
import type {
  GetQueryResponse,
  GetPathParams,
  Get401,
} from '../../types/Get.ts';
import type { RequestConfig, ResponseErrorConfig } from '~/lib/api/axiosClient';

function getGetUrl(jobId: GetPathParams['jobId']) {
  const res = { method: 'GET', url: `/managed-jobs/${jobId}` as const };
  return res;
}

/**
 * {@link /managed-jobs/:jobId}
 */
export async function get(
  jobId: GetPathParams['jobId'],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetQueryResponse,
    ResponseErrorConfig<Get401>,
    unknown
  >({ method: 'GET', url: getGetUrl(jobId).url.toString(), ...requestConfig });
  return res.data;
}
